import { useTranslations } from "next-intl";

export const genreIds: Record<
  string,
  {
    id: number;
    translationKey: Parameters<
      ReturnType<typeof useTranslations<"GenrePage.genres">>
    >[0];
  }
> = {
  music: { id: 34, translationKey: "music" },
  "theatre-arts": { id: 35, translationKey: "theatreandarts" },
  "festivals-lifestyle": { id: 36, translationKey: "festivalsandlifestyle" },
  experiences: { id: 37, translationKey: "experiences" },
  sport: { id: 38, translationKey: "sport" },
  nightlife: { id: 39, translationKey: "nightlife" },
  whatson: { id: 0, translationKey: "whatson" },
};

export const auGenreIds: Record<
  string,
  {
    id: number;
    translationKey: Parameters<
      ReturnType<typeof useTranslations<"GenrePage.genres">>
    >[0];
  }
> = {
  experiences: { id: 37, translationKey: "experiences" },
};
